<h1>Reports</h1>
<mat-divider></mat-divider>

<mat-card class="p-[10px] mt-[30px] mx-auto w-[70%]">
    <h3>Scholarship Details</h3>
    <div class="flex justify-between">
        <span>Generate an excel file with all the scholarships for this year and all details about those scholarships including minumun GPA, essay requirements, and school list</span>
        <button mat-raised-button (click)="scholarshipDetails()">Run Report</button>
    </div>
</mat-card>

<mat-card class="p-[10px] mt-[30px] mx-auto w-[70%]">
    <h3>Application Status</h3>
    <div class="flex justify-between">
        <span>Generate an excel file with all the applications for this year grouped by school and the status of those applications including student name, application start date, and application status</span>
        <button mat-raised-button (click)="applicationStatus()">Run Report</button>
    </div>
</mat-card>